import {RegistrationActions} from '../registration-react/registration.actions';

export class LoadingService {

  show() {
    RegistrationActions.setLoading(true);
  }

  hide() {
    RegistrationActions.setLoading(false);
  }
}


// WEBPACK FOOTER //
// ./services/loading.service.js